import { useEffect, useState } from "react";
import { listLabelCategories, type LabelCategory } from "@/api/labelCategory";

/**
 * 갈래 카탈로그 적재 seam. 값을 갈래로 묶어 표시하는 화면이 이 훅으로 갈래를 받는다.
 *
 * 적재 자체는 `listLabelCategories` 의 세션 캐시가 소유한다. 이 훅이 추가하는 것은 **언제 받을지**
 * 뿐이다. `enabled` 가 false 인 동안에는 요청하지 않는다. 라벨링 가이드는 `?` 를 눌러야 열리는
 * 화면이다. 그 세션에서 한 번도 열지 않으면 요청이 0 번이어야 한다.
 *
 * `useLabelCatalog` 과 달리 적재 상태를 구분하지 않는다. 소비처는 갈래를 받지 못했을 때 쓸
 * **폴백을 가진다**(갈래 없이 한 묶음으로 그린다). 도착 전과 실패의 화면이 같으므로 상태를
 * 나눠도 쓸 곳이 없다.
 *
 * @param key 라벨 key. 예) `quality`
 * @param enabled 받을지 여부. false 면 빈 배열을 반환하고 요청하지 않는다.
 * @returns 갈래 목록. 아직 받지 못했으면 빈 배열.
 */
export function useLabelCategories(key: string, enabled: boolean): readonly LabelCategory[] {
  const [categories, setCategories] = useState<readonly LabelCategory[]>([]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    let cancelled = false;
    listLabelCategories(key)
      .then((next) => {
        if (!cancelled) {
          setCategories(next);
        }
      })
      // 갈래를 받지 못하면 소비처는 갈래 없이 그린다. 호출부에 알려도 호출부가 할 수 있는 일이 없다.
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [key, enabled]);

  return categories;
}
